import { orderBy } from "@progress/kendo-data-query";
import moment from "moment";
import gridbase from "../../../components/gridComponentBase.js";
import api from "../../../services/api";
import { mapGetters } from "vuex";
import cellEditCommand from "../../../components/grid/cellEditCommand/cellEditCommand.vue";

export default {
	extends: gridbase,
	components: {},
	data: function() {
		return {
			vehicleIdFilterField: "number_plate",
			isInEditMode: false,
			dataReady: false,
			showEditModal: false,

			columns: [
				{
					field: "id",
					title: "id",
					configId: "id",
					width: "100",
					headerCell: "myHeaderTemplate",
					editable: false,
					filterable: false,
					hidden: true
				},
				{
					field: "name",
					title: "Nome",
					configId: "name",
					// width: "350",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					format: "link",
					filterable: false
				},
				{
					field: "enabled",
					title: "Attivo",
					configId: "enabled",
					width: "120",
					cell: "myCellTemplate",
					format: "boolean",
					filter: "boolean",
					headerCell: "myBooleanHeaderTemplate",
					filterable: true,
					editable: true
				},
				{
					field: "realtime_box",
					title: "REALTIME",
					configId: "realtime_box",
					width: "130",
					cell: "myCellTemplate",
					format: "boolean",
					filter: "boolean",
					headerCell: "myBooleanHeaderTemplate",
					filterable: true,
					editable: true
				},
				{
					field: "type_box",
					title: "Tipologia",
					configId: "type_box",
					width: "120",
					headerCell: "myAlertTypesHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: true
				},
				{
					field: "frequency",
					title: "Frequenza di verifica (giorni)",
					configId: "frequency",
					width: "120",
					headerCell: "myHeaderTemplate",
					format: "numeric-int",
					cell: "myCellTemplate",
					editable: false,
					filterable: false
				},
				{
					field: "vehiclesDesc",
					title: "Veicoli",
					configId: "vehiclesDesc",
					width: "350",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: false,
					sortable: false,
				},
				{
					field: "daysDesc",
					title: "Giorni",
					configId: "daysDesc",
					width: "350",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					editable: false,
					filterable: false,
					sortable: false,
				},
			],

			items: [],
			canExportGridData: false,

			//table filters
			alertTypes: [],
			alertTypesSelected: [],

			//Edit object
			name: "",
			active: false,
			frequency_day_update: 1,
			recipients: "",
			recipientsCopy: "",
			object: "",
			message: "",
			note: "",
			updated: null,

			hasDivisions: false,

			datePickerFooter: "Oggi - #=kendo.toString(data, 'dd MMMM yyyy') #"
		};
	},
	created() {
		this.hasSelectedMode = true;
		this.hasEditableMode = true;

		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;
		if (this.vehicleIdFilterField == "code") this.vehicleIdFilterField = "vehicle_codes";

		if (this.settings && this.settings.defaultPageSize && this.settings.defaultPageSize > 0) {
			this.query.pageSize = parseInt(this.settings.defaultPageSize);
		}

		this.getConfig();
		this.getAlertTypes();

		this.$nextTick(function() {
			this.getData();
		});
	},
	methods: {
		goTo(dataItem) {
			var id = dataItem.id;

			this.$router.push({
				name: "PREFERENCES_DETAIL_ALERT_BOX",
				params: {
					id: id
				}
			});
		},
		// updatedDateChange(item) {
		// 	var updatedDate = moment(item.sender.value()).startOf("days");
		// 	this.updated = updatedDate;
		// },
		// editRowItem(e) {
		// 	let dataItem = e.dataItem;
		// 	console.log(dataItem);

		// 	this.openEditModal();
		// },
		// openEditModal() {
		// 	this.showEditModal = true;
		// },
		// closeEditModal() {
		// 	this.showEditModal = false;
		// },
		internalFiltersToUpdate(e) {
			if (e.field == "type_box") {
				this.alertTypesSelected = [];
			}
		},
		getAlertTypes() {
			var self = this;

			api.getAlertTypes().then(res => {
				self.alertTypes = res.map(function(type) {
					return {
						id: type.key,
						value: type.value
					};
				});
			});
		},
		getConfig: function() {
			var self = this;

			api.getViewConfig("fleerun_alerts").then(res => {
				self.config = res;
				if (self.config && self.config.length > 0) {
					var orderedConfigColumn = self._.orderBy(self.config, "order", "asc");

					orderedConfigColumn.forEach(column => {
						var defColumn = self.columns.find(function(f) {
							return f.configId === column.field;
						});

						if (defColumn && column.enabled && (!defColumn.permit || self[defColumn.permit])) {
							if (column.label && column.label.toLowerCase().indexOf("co2") >= 0) {
								column.label = column.label.toLowerCase().replace("co2", "co<sub>2</sub>");
							}
							defColumn.title = column.label;

							self.columnsToShow.push(defColumn);
						}
					});

					if (self.columnsToShow.length > 0) {
						var columnsByPassConfig = self._.filter(self.columns, function(item) {
							return item.configByPass;
						});

						for (var i = 0; i < columnsByPassConfig.length; i++) {
							//self.columnsToShow.push(columnsByPassConfig[i]);
							var index = columnsByPassConfig[i].order || 0;
							self.columnsToShow.splice(index, 0, columnsByPassConfig[i]);
						}
					}
				}
			});
		},
		sortChangeHandler: function(e) {
			this.sort = e.sort;
			this.getData();
		},
		filterChange: function(ev) {
			this.filter = ev.filter;
		},
		pageChangeHandler: function(event) {
			this.skip = event.page.skip;
			this.take = event.page.take;

			if (this.skip === 0) {
				this.query.page = 0;
			}
			this.query.page = this.skip / this.take;

			this.getData();
		},
		getData: function() {
			var self = this;
			this.loading = true;

			var data = this._.clone(this.query);

			if (this.columnFilters) {
				for (var i = 0; i < this.columnFilters.length; i++) {
					var clmF = this.columnFilters[i];

					for (var j = 0; j < clmF.filter.filters.length; j++) {
						var filt = clmF.filter.filters[j];
						var field = filt.field;
						var value = filt.value;

						data[field] = value;
					}
				}
			}

			api.getAlertsData(data).then(res => {
				self.loading = false;

				self.items = res.items.map(function(item) {
					var row = {};
					self.columns.forEach(function(c) {
						row[c.field] = item[c.field];
					});

					self.dataReady = true;

					return row;
				});

				self.total = res.totalCount;
			});
		},

		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		},

		downloadXlsx(type) {
			var self = this;
			if (type == "csv") this.query["format"] = "csv";
			api.exportXlsx("", this.query).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `Veicoli.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		}
	},

	computed: {
		...mapGetters(["settings", "scopes"]),
		updatedDateString() {
			if (this.updated && this.updated.isValid()) return moment(this.updated).format("DD MMMM YYYY");
			return "";
		}
	}
};
